import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { EditData, GetData, DeleteData } from "./Components/Services";
import DataTable from "../../../Common/Components/DataTable";
import CommonFrom from "../../../Common/Components/Form";
import Loading from "../../../Common/Components/Loading";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { input } from "./Create";
function List() {
  const initialState = {
    loading: true,
    data: {
      current_page: null,
      data: null,
    },
    modal: false,
  };
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    Handler();
  }, []);
  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };

  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({ ...data, option_id: state.data.data[state.modal - 1].id });
    GetData().then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | امکانات</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "عنوان",
            key: "name",
          },
          {
            title: "وضعیت",
            key: "status",
            type: "enum",
            enum: {
              active: "فعال",
              deactive: "غیر فعال",
            },
          },
          { title: "ایکون", key: "icon", type: "icon" },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="امکاناتی ثبت نشده است"
        list={state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data.current_page}
        header="لیست امکانات"
        textbtn="ایجادامکانات"
        linkbtn="/Admin/Option/Create"
        links={[
          {
            function: selected => {
              HandlerDelete({ option_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />
      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش امکانات"}
      >
        <CommonFrom
          loading={state.loading}
          edit={true}
          form={input}
          btnName={"ثبت اطلاعات امکانات"}
          value={
            state.data && state.data.data && state.data.data[state.modal - 1]
          }
          submit={HandlerEdit}
        />
      </CustomModal>
    </Fragment>
  );
}

export default List;
